import React from "react";

function privacy() {
  return (
    <div>
      <div className="wrapper">
        <div className="breadcrumb-block">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-10">
                <div className="barren-breadcrumb">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Privacy Policy
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="event-dt-block p-80">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="tab-content pt-0 p-2 mt-5 mt-lg-0">
                  <div
                    className="tab-pane fade show active"
                    id="sellers"
                    role="tabpanel"
                  >
                    <div className="privacy-main-title">
                      <h4>Privacy Policy</h4>
                    </div>
                    <div className="privacy-content">
                      <p>
                      At FEventopia, we are committed to protecting your privacy and ensuring that your personal information is 
                      handled in a safe and responsible manner. This Privacy Policy outlines the types of personal information 
                      we collect, how we use and protect that information, and your rights regarding your personal data. 
                      By using our services, you agree to the terms of this policy. 
                      We encourage you to read this policy carefully and contact us if you have any questions or concerns.
{" "}
                      </p>
                      <h5>Which entities does this privacy policy cover?</h5>
                      <p>
                      This privacy policy applies to all services and products provided by these entities, both online and offline.
                      </p>
                      <h5>What personal information do we collect?</h5>
                      <p>
                      We collect various types of personal information, including but not limited to:<br/>
                      Name and contact details (e.g., email address, phone number)
                      </p>
                      <h5>Why do we collect your personal information?</h5>
                      <p>
                      We collect your personal information for several reasons, including:<br/>
                      To provide and improve our services and products<br/>
                      To communicate with you and respond to your inquiries<br/>
                      To personalize your experience on our website<br/>
                      To process transactions and manage your account<br/>
                      To comply with legal obligations and enforce our policies<br/>
                      To conduct market research and analyze trends
                      </p>
                      <h5>
                        How do we store and protect your personal information?
                      </h5>
                      <p>
                      We store your personal information on secure servers and implement 
                      a variety of security measures to protect your data from unauthorized access,
                      alteration, disclosure, or destruction. 
                      </p>
                      <h5>
                        Should you wish to enquire regarding our security
                        policies and practices
                      </h5>
                      <p>
                      For any inquiries regarding our security policies and practices,
                      please contact our support team at email address or phone number.
                      </p>
                      <span>your request within 30 days.</span>
                      <span>
                        Phone:{" "}
                        <a href="#" className="a-link">
                        (028) 7300 5588
                        </a>{" "}
                        (from fpt student affairs office)
                      </span>
                      <span>
                        Email:{" "}
                        <a href="#" className="a-link">
                        daihoc.hcm@fpt.edu.vn
                        </a>{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default privacy;
